import { render } from "./footerHome.vue?vue&type=template&id=5906c15c&scoped=true"
import script from "./footerHome.vue?vue&type=script&lang=js"
export * from "./footerHome.vue?vue&type=script&lang=js"

import "./footerHome.vue?vue&type=style&index=0&id=5906c15c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5906c15c"]])

export default __exports__